var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wrapper"},[(_vm.chartData.description)?_c('p',{staticClass:"font-weight-light text-caption mb-2"},[_vm._v(_vm._s(_vm.chartData.description))]):_vm._e(),_c('Bar',{key:_vm.chartKey,ref:"chart",staticClass:"mb-4",attrs:{"data":_vm.chartData.data,"options":_vm.chartData.options}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }